<template>
  <component
    :is="component.component.name"
    v-for="(component, index) in specificComponents"
    :key="`dynamicComponent-${index}`"
    :component="component"
  ></component>
</template>

<script lang="ts">
// layouts
import FooterOne from '~/components/theme9/base/footer/FooterOne.vue';
import HeaderOne from '~/components/theme9/base/header/HeaderOne.vue';

// library components
import FormContainer from '~/components/library/FormContainer.vue';

// theme9 components
import TestTheme9 from '~/components/theme9/components/TestTheme9.vue';
import Properties from '~/components/theme9/properties/Properties.vue';
import RegisterEntry from '~/components/theme9/register/RegisterEntry.vue';
import Register from '~/components/theme9/register/Register.vue';
import IntroSection from '~/components/theme9/components/IntroSection.vue';
import ContentBox from '~/components/theme9/components/ContentBox.vue';
import CountSection from '~/components/theme9/components/CountSection.vue';
import AnimationText from '~/components/theme9/components/AnimationText.vue';
import OurGuide from '~/components/theme9/components/OurGuide.vue';
import InfoBox from '~/components/theme9/components/InfoBox.vue';
import OurHist from '~/components/theme9/components/OurHist.vue';
import OurValues from '~/components/theme9/components/OurValues.vue';
import WhySection from '~/components/theme9/components/WhySection.vue';
import VideoTestimonial from '~/components/theme9/components/VideoTestimonial.vue';
import VideoSection from '~/components/theme9/components/VideoSection.vue';
import ContactUs from '~/components/theme9/components/ContactUs.vue';
import BranchMap from '~/components/theme9/components/BranchMap.vue';
import VideoBox from '~/components/theme9/components/VideoBox.vue';
import TakeAction from '~/components/theme9/components/TakeAction.vue';
import HeroSection from '~/components/theme9/components/HeroSection.vue';
import GoogleReview from '~/components/theme9/components/GoogleReview.vue';
import OurValuations from '~/components/theme9/components/OurValuations.vue';
import AboutAccordions from '~/components/theme9/components/AboutAccordions.vue';
import ManageCard from '~/components/library/ManageCard.vue';
import SocialGallery from '~/components/theme9/components/SocialGallery.vue';

// common
import PropertiesEntry from '~/components/common/properties/PropertiesEntry.vue';
import Separator from '~/components/library/Separator.vue';
import RedirectTo from '~/components/common/RedirectTo.vue';
import NotFoundPage from '~/components/theme9/components/NotFoundPage.vue';
// blogs components
import {
  LibraryPropertiesOnTheFlySearchBox,
  Theme9BlogsPage,
  Theme9BlogsOurBlog,
  Theme9PropertiesLatestProperties,
  Theme9PropertiesPropertyDetail,
  Theme9BlogsBlogDetail,
} from '#components';
import UpdateProfileEntry from '~/components/library/heads_up_alerts/UpdateProfileEntry.vue';
import LoginBox from '~/components/library/LoginBox.vue';

export default defineNuxtComponent({
  props: {
    specificComponents: {
      required: false,
      default: () => [],
    },
  },

  components: {
    HeaderOne,
    FooterOne,
    FormContainer,
    Properties,
    Register,
    RegisterEntry,
    NotFoundPage,
    OurGuide,
    PropertiesEntry,
    Separator,
    RedirectTo,
    OnTheFlyPropertySearchBox: LibraryPropertiesOnTheFlySearchBox,
    PropertyDetail: Theme9PropertiesPropertyDetail,
    LatestProperties: Theme9PropertiesLatestProperties,
    OurBlog: Theme9BlogsOurBlog,
    BlogsPage: Theme9BlogsPage,
    BlogDetail: Theme9BlogsBlogDetail,
    UpdateProfileEntry,
    LoginBox,
    IntroSection,
    ContentBox,
    AnimationText,
    InfoBox,
    CountSection,
    VideoBox,
    BranchMap,
    OurValues,
    WhySection,
    TakeAction,
    OurHist,
    ContactUs,
    ManageCard,
    VideoTestimonial,
    VideoSection,
    TestTheme9,
    GoogleReview,
    HeroSection,
    OurValuations,
    AboutAccordions,
    SocialGallery,
  },
});
</script>
